const calculateAvatarScale = (naturalWidth, naturalHeight, imageScale) => {
  if (naturalWidth < naturalHeight) {
    return `${imageScale}% auto`;
  } else {
    return `auto ${imageScale}%`;
  }
};

export default calculateAvatarScale;
